module.exports = __webpack_public_path__ + "user/static/media/logo.1c530a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/Logo/logo.png
// module id = 404
// module chunks = 38